import { Component, inject, Input, input } from "@angular/core";
import { ControlContainer, ReactiveFormsModule } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";

@Component({
  selector: "app-place-name-form-field",
  imports: [UiKitModule, ReactiveFormsModule],
  templateUrl: "./place-name-form-field.component.html",
  viewProviders: [
    {
      provide: ControlContainer,
      useFactory: (): ControlContainer => inject(ControlContainer, { skipSelf: true }),
    },
  ],
  standalone: true,
})
export class PlaceNameFormFieldComponent {
  @Input() isReadonly!: boolean;
  @Input() required!: boolean;
  isWriteable = input(false);
}
